/**
 * API呼び出しヘルパー関数
 * デジタルツール認証トークンを自動的に付与
 */

import { shouldUseSSOAuth } from './env';

// デジタルツール認証インスタンス（循環参照を避けるため、遅延読み込み）
let digitalToolsAuthInstance = null;

export const setDigitalToolsAuth = (auth) => {
  digitalToolsAuthInstance = auth;
};

/**
 * API呼び出し用のヘルパー関数
 */
export const apiCall = async (endpoint, options = {}) => {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
  const url = `${API_BASE_URL}${endpoint}`;
  
  try {
    const headers = {
      'Accept': 'application/json',
      ...(options.headers || {}),
    };
    
    // デジタルツール認証トークンを取得して付与（SSO認証を使用する環境のみ）
    // デジタルツールのAPIエンドポイントの場合は認証トークンを付与しない
    const digitalToolsUrl = process.env.REACT_APP_DIGITAL_TOOLS_URL;
    const isDigitalToolsEndpoint = digitalToolsUrl && url.startsWith(digitalToolsUrl);
    
    if (shouldUseSSOAuth() && !isDigitalToolsEndpoint && digitalToolsAuthInstance && digitalToolsAuthInstance.isAuthenticated()) {
      const token = await digitalToolsAuthInstance.getAuthToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }
    
    // FormDataの場合はContent-Typeを自動設定させる
    if (!(options.body instanceof FormData)) {
      headers['Content-Type'] = headers['Content-Type'] || 'application/json';
    }
    
    const response = await fetch(url, {
      ...options,
      headers,
    });
    
    // 認証エラーの場合は再認証を試みる（SSO認証を使用する環境のみ）
    if (shouldUseSSOAuth() && response.status === 401 && !isDigitalToolsEndpoint && digitalToolsAuthInstance) {
      console.log('認証エラーが発生しました。再認証を試みます...');
      const refreshedToken = await digitalToolsAuthInstance.getAuthToken(true);
      if (refreshedToken) {
        headers['Authorization'] = `Bearer ${refreshedToken}`;
        // リトライ
        return fetch(url, {
          ...options,
          headers,
        });
      }
    }
    
    return response;
  } catch (error) {
    console.error('API呼び出しエラー:', error);
    throw error;
  }
};

